<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader>
                    <strong>Клиенты</strong>
                </CCardHeader>
                <CCardBody>
                    <CustomerLogsTable
                        :list.sync="items"
                        :use-filter="true"
                        :items-count="itemsCount"
                        @set-filter="setFilter"
                    />
                    <CPagination
                        :active-page.sync="activePage"
                        class="mt-4"
                        :pages="total"
                        align="center"
                    />
                </CCardBody>
                <CCardFooter />
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import CustomerLogsTable from '@/components/CustomerLogsTable';
    const { ITEMS_PER_PAGE } = require('../../utils/views');

    export default {
        name: 'Customers',

        components: {
            CustomerLogsTable,
        },

        data() {
            return {
                items: [],
                itemsCount: 0,
                total: 1,
                filter: '',
                timerId: null,
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'loadData',
            sorter: 'loadData',
            filter: 'loadData',
        },

        mounted() {
            this.loadData();
        },

        beforeDestroy() {},

        methods: {
            loadData() {
                let filter = null;
                try {
                    filter = JSON.parse(this.filter);
                } catch (e) {}
                const params = {
                    page: this.activePage,
                    pageSize: ITEMS_PER_PAGE,
                    filter,
                };
                // Vue.axios.get("/customer-log/update");

                Vue.axios
                    .get('/customer-log', { params })
                    .then(resp => {
                        this.items = resp.data.results;
                        this.itemsCount = resp.data.total;
                        this.total = Math.ceil(resp.data.total / ITEMS_PER_PAGE);
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки логов. ' + err);
                    });
            },
            setFilter(filter) {
                this.filter = JSON.stringify(filter);
            },
        },
    };
</script>
